import React from 'react';
import { Box, Grid, IconButton, Stack, Tooltip, Typography } from '@mui/material';
import ListAndView from '../elements/ListAndView';
import LoupeIcon from '@mui/icons-material/Loupe';
import RefreshIcon from '@mui/icons-material/Refresh';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import OpenStreetMaps from '../map/OpenStreetMaps';
import DialogYesNo from '../elements/DialodYesNo';
import axios from 'axios';
import AddCultureDialog from './AddCultureDialog';
import MiniDrawer from '../Header';
const Cultures = ({ token }) => {
    const [cultures, setCultures] = React.useState([]);
    const [selected, setSelected] = React.useState(null);
    const [deleteDialog, setDeleteDialog] = React.useState(false);
    const [addDialog, setAddDialog] = React.useState(false);
    const map = React.useRef(null);
    const loadData = () => {
        axios.get('/culture/list', {
            headers: { Authorization: `Bearer ${token}` }
        }).then(res => {
            setCultures(res.data.items || []);
        });
    };
    React.useEffect(() => {
        if (!selected || !map.current)
            return;
        if (selected.fields.length === 0)
            return;
        const ids = selected.fields.map(f => f.id).join(",");
        map.current.setUrl(`/field/by_ids?ids=${ids}`, { lat: 49.9714, lng: 82.6059 });
    }, [selected]);
    const getIcon = (name) => {
        const n = name.toLowerCase();
        if (n.includes('пшен'))
            return '🌾';
        if (n.includes('куку'))
            return '🌽';
        if (n.includes('подсол'))
            return '🌻';
        if (n.includes('соя'))
            return '🌱';
        if (n.includes('рапс'))
            return '🌼';
        return '🌿';
    };
    const deleteCulture = () => {
        if (!selected)
            return;
        axios.delete('/culture/delete', {
            headers: { Authorization: `Bearer ${token}` },
            data: { items: [selected.id] }
        }).then(() => {
            setSelected(null);
            setDeleteDialog(false);
            loadData();
        });
    };
    return (React.createElement(MiniDrawer, { type: "cultures" },
        React.createElement(Stack, { spacing: 2, sx: { padding: 0, flex: '1 1 auto', pt: 0 } },
            React.createElement(ListAndView, { left: React.createElement(React.Fragment, null,
                    React.createElement("div", { style: {
                            backgroundColor: '#fafafa',
                            height: '64px',
                            borderBottom: '1px solid #eaeaea',
                            display: 'flex',
                            alignItems: 'center',
                            padding: '0px 5px',
                            gap: 0
                        } },
                        React.createElement(Tooltip, { title: "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u043A\u0443\u043B\u044C\u0442\u0443\u0440\u0443" },
                            React.createElement(Stack, { alignItems: "center", sx: { width: 55 } },
                                React.createElement(IconButton, { color: "success", size: "small", onClick: () => setAddDialog(true) },
                                    React.createElement(LoupeIcon, null)),
                                React.createElement(Typography, { variant: "caption", sx: {
                                        fontSize: 7,
                                        lineHeight: 1,
                                        mt: -0.3,
                                        textAlign: 'center',
                                        whiteSpace: 'pre-line',
                                        userSelect: "none"
                                    } }, "Добавить"))),
                        React.createElement(Tooltip, { title: "\u041E\u0431\u043D\u043E\u0432\u0438\u0442\u044C \u0441\u043F\u0438\u0441\u043E\u043A" },
                            React.createElement(Stack, { alignItems: "center", sx: { width: 55 } },
                                React.createElement(IconButton, { size: "small", onClick: loadData },
                                    React.createElement(RefreshIcon, null)),
                                React.createElement(Typography, { variant: "caption", sx: {
                                        fontSize: 7,
                                        lineHeight: 1,
                                        mt: -0.3,
                                        textAlign: 'center',
                                        whiteSpace: 'pre-line'
                                    } }, "Обновить")))),
                    React.createElement(Box, { sx: {
                            height: 'calc(100vh - 180px)',
                            overflowY: 'auto'
                        } }, cultures.map(c => (React.createElement(Box, { key: c.id, onClick: () => setSelected(c), sx: {
                            px: 2,
                            py: 2,
                            cursor: 'pointer',
                            borderBottom: '1px solid #f0f0f0',
                            backgroundColor: (selected === null || selected === void 0 ? void 0 : selected.id) === c.id ? '#f5f9f5' : 'white',
                            '&:hover': { backgroundColor: '#f9f9f9' }
                        } },
                        React.createElement(Stack, { direction: "row", spacing: 2, alignItems: "center" },
                            React.createElement(Box, { sx: {
                                    fontSize: 28,
                                    width: 40,
                                    textAlign: 'center'
                                } }, getIcon(c.cultures_name)),
                            React.createElement(Box, null,
                                React.createElement(Typography, { fontWeight: 500 }, c.cultures_name),
                                React.createElement(Typography, { variant: "caption", color: "text.secondary" },
                                    "\u041A\u043E\u0434: ",
                                    c.cultures_code,
                                    " \u00B7 \u041F\u043E\u043B\u0435\u0439: ",
                                    c.fields.length)))))))), view: React.createElement(Grid, { container: true, sx: { height: '100%' } },
                    selected && (React.createElement(Grid, { item: true, xs: "auto", sx: { p: 3, borderRight: '1px solid #eaeaea', minWidth: 300 } },
                        React.createElement(Typography, { variant: "h6", fontWeight: 600 },
                            getIcon(selected.cultures_name),
                            " ",
                            selected.cultures_name),
                        React.createElement(Typography, { variant: "body2", sx: { mt: 1 } },
                            "\u041A\u043E\u0434 \u043A\u0443\u043B\u044C\u0442\u0443\u0440\u044B: ",
                            selected.cultures_code),
                        React.createElement(Typography, { variant: "body2", sx: { mt: 2 } },
                            "\u0418\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u0435\u0442\u0441\u044F \u0432 ",
                            selected.fields.length,
                            " \u043F\u043E\u043B\u044F\u0445"),
                        React.createElement(Stack, { direction: "row", spacing: 3, sx: { mt: 3 } },
                            React.createElement(Stack, { alignItems: "center" },
                                React.createElement(IconButton, { size: "small" },
                                    React.createElement(EditIcon, null)),
                                React.createElement(Typography, { variant: "caption", sx: { fontSize: 8 } }, "\u0420\u0435\u0434\u0430\u043A\u0442\u0438\u0440\u043E\u0432\u0430\u0442\u044C")),
                            React.createElement(Stack, { alignItems: "center" },
                                React.createElement(IconButton, { size: "small", color: "error", onClick: () => setDeleteDialog(true) },
                                    React.createElement(DeleteIcon, null)),
                                React.createElement(Typography, { variant: "caption", sx: { fontSize: 8 } }, "\u0423\u0434\u0430\u043B\u0438\u0442\u044C"))))),
                    React.createElement(Grid, { item: true, xs: true },
                        React.createElement(OpenStreetMaps, { ref: map, token: token, url: null, item: 1, draw: true, showStantions: `stantions` }))) })),
        React.createElement(DialogYesNo, { title: "\u0423\u0434\u0430\u043B\u0435\u043D\u0438\u0435 \u043A\u0443\u043B\u044C\u0442\u0443\u0440\u044B", question: `Удалить культуру ${selected === null || selected === void 0 ? void 0 : selected.cultures_name}?`, open: deleteDialog, description: {
                title: "Связанные поля:",
                values: (selected === null || selected === void 0 ? void 0 : selected.fields.map(f => f.name)) || []
            }, yes: deleteCulture, no: setDeleteDialog }),
        React.createElement(AddCultureDialog, { token: token, open: addDialog, setState: setAddDialog, update: loadData })));
};
export default Cultures;
